const PRODUCTOPTIONSSELECTED_BUNDLE_ONLOAD = 'PRODUCTOPTIONSSELECTED_BUNDLE_ONLOAD';

export default {
    PRODUCTOPTIONSSELECTED_BUNDLE_ONLOAD,
};
